import React from "react";
import { Main } from "../components/sections/modifyProduct/Main";

export const ModifyProduct = () => {
  return <Main />;
};
